export enum UtmAcquisitionProduct {
  PERSONAL_LOANS = 'personal_loans',
}
